import { ApiConfigration } from '@/hotdesk-ui/common-classes/api-configuration';
import { Carousel } from '@/hotdesk-ui/enum/listing-workspace';
import { ListingService } from '@/hotdesk-ui/services/listing.service';
import type { GeoCodeResult } from '@/hotdesk-ui/types/geo-code-result.type';
import type { ReadOnlyListing, User } from 'hotdesk_typescript';

/** Default search radius (km) — matches `listing.slice` initial `radius`. */
const NEARBY_RADIUS_KM = 15;

const subscriptionIdIn = (user: User): string =>
    user.userSubscriptions?.map((s) => String(s.id)).join(',') ?? '';

/**
 * Closest workspace title for the user's current geo (API `loc` sort).
 * This is what PostHog "Nearest Workspace" should reflect on web.
 */
export async function fetchNearestWorkspaceNameForTracking(
    geo: GeoCodeResult | null | undefined,
    languageCode: string,
    user: User,
    token?: string
): Promise<string> {
    const lat = geo?.lat;
    const lng = geo?.log;
    if (lat == null || lng == null) return '';

    try {
        const apiConfig = await new ApiConfigration().getApiConfig(
            languageCode,
            token
        );
        const listingService = new ListingService(apiConfig);
        const params = listingService.getListingsDataParams(
            Carousel.workspace,
            1,
            0,
            { lat, lng, radius: NEARBY_RADIUS_KM },
            {},
            '',
            '',
            subscriptionIdIn(user)
        );
        if (!params) return '';

        const res = await listingService.getallListings(params);
        const first = res.results?.[0] as ReadOnlyListing | undefined;
        return first?.workspace?.title?.trim() ?? '';
    } catch {
        return '';
    }
}
